import emailConfig from './email.config';
import emailControllers from './email.controllers';

const emailModule = angular
    .module('advinda.email', [
        emailControllers.name
    ])
    .config(emailConfig);

export default emailModule;



/** WEBPACK FOOTER **
 ** ./src/app/components/email/email.module.js
 **/